import { ActivityEntity, ActivityType } from 'src/models/dto/ActivityDTO'

export type IScreenEntity = ActivityEntity & IScreenDTO

export interface IScreenDTO {
    id: string
    name: string
    interviewValidityDurationDays: number | null
    numberOfCompetencies: number | null // UI-only, derived from iscreenCompetencies.length
    iscreenCompetencies: IscreenCompetencyDTO[]
    type: ActivityType
    ppt: string
}

export interface IscreenCompetencyDTO {
    id: string // UI-only for React keys
    competencyType: string | null
    iscreenCompetencyTimeLimitSeconds: number | null
}

/** The competency types an iScreen page offers, with their display names. */
export const COMPETENCY_TYPE_OPTIONS = [
    { name: 'Core Competency', value: 'CORE' },
    {
        name: 'Leadership Principle',
        value: 'LEADERSHIP',
    },
    { name: 'Requisition', value: 'REQUISITION' },
    { name: 'Technical/Functional', value: 'TECHNICAL' },
]

/** A competency type's display name, e.g. "Technical/Functional" for TECHNICAL. */
export const getCompetencyTypeName = (value: string | null) => {
    if (!value) return undefined
    return COMPETENCY_TYPE_OPTIONS.find((opt) => opt.value === value)?.name
}

export const isIScreenEntity = (entity: ActivityEntity): entity is IScreenEntity => {
    return entity.type === ActivityType.LaunchIScreen
}
